/**
 * Returns true if the value is a valid http/https URL.
 * When true, the icon is rendered as an <img>; otherwise omitted.
 */
export const isIconUrl = (value: string | null | undefined): boolean => {
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

/**
 * Returns true if href is a valid relative path or absolute http/https URL.
 * When false, the action tile should be rendered as non-clickable.
 */
export const isValidHref = (href: string | null | undefined): boolean => {
  if (!href) return false;
  if (href.startsWith("/")) return true;
  try {
    const url = new URL(href);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};
